/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/29/14
 * Time: 6:57 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var KPsSearchController = require("connection-controllers/KPsTab/KPsSearchController");
    var PageSnippetsController = require("connection-controllers/KPsTab/PageSnippetsController");
    var AreaSnippetsController = require("connection-controllers/KPsTab/AreaSnippetsController");
    var RecentSnippetsController = require("connection-controllers/KPsTab/RecentSnippetsController");
    var KPsTabLayout = require("connection-views/layouts/KPsTab/KPsTabLayout");
    var SnippetModel = require("connection-models/KPsTab/SnippetModel");
    var CP_CONST = require("connection-const");


    var KPsTabController = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        KPsTabController = Marionette.Controller.extend({
            initialize: function (options) {
                this.connectionPanelContextModel = options.connectionPanelContextModel;
                this.kpsTabLayout = new KPsTabLayout();
                LEConnection.vent.trigger("MainContainerController::showRegion:KPsRegion", {
                    view: this.kpsTabLayout
                });
                this._bindEvents();
                this._startSnippetControllers();
                this._setListeners();
            },
            _startSnippetControllers: function () {
                this.kpsSearchController = new KPsSearchController({
                    connectionPanelContextModel: this.connectionPanelContextModel
                });
                this.pageSnippetsController = new PageSnippetsController({
                    connectionPanelContextModel: this.connectionPanelContextModel
                });
                this.areaSnippetsController = new AreaSnippetsController({
                    connectionPanelContextModel: this.connectionPanelContextModel
                });

                this.recentSnippetsController = new RecentSnippetsController({
                    connectionPanelContextModel: this.connectionPanelContextModel
                });

            },

            _bindEvents: function () {
                LEConnection.vent.on("KPsTabController::showRegion:searchInputRegion", this._showSearchInputRegion, this);
                LEConnection.vent.on("KPsTabController::showRegion:searchResultsRegion", this._showSearchResultsRegion, this);
                LEConnection.vent.on("KPsTabController::showRegion:whatsNewRegion", this._showWhatsNewRegion, this);
                LEConnection.vent.on("KPsTabController::showRegion:pageRegion", this._showPageRegion, this);
                LEConnection.vent.on("KPsTabController::showRegion:areaRegion", this._showAreaRegion, this);
                LEConnection.vent.on("KPsTabController::showRegion:recentRegion", this._showRecentRegion, this);

                LEConnection.vent.on("KPsTabController::closeRegion:searchInputRegion", this._closeSearchInputRegion, this);
                LEConnection.vent.on("KPsTabController::closeRegion:searchResultsRegion", this._closeSearchResultsRegion, this);
                LEConnection.vent.on("KPsTabController::closeRegion:whatsNewRegion", this._closeWhatsNewRegion, this);
                LEConnection.vent.on("KPsTabController::closeRegion:pageRegion", this._closePageRegion, this);
                LEConnection.vent.on("KPsTabController::closeRegion:areaRegion", this._closeAreaRegion, this);
                LEConnection.vent.on("KPsTabController::closeRegion:recentRegion", this._closeRecentRegion, this);

                LEConnection.vent.on("KPsTabController::loader:show", this._setLoader, this);
                LEConnection.vent.on("KPsTabController::loader:hide", this._closeLoader, this);

                LEConnection.vent.once("KPsTabController::noData:show", this._setNoData,this);

                LEConnection.vent.on('Article:requested', this._onArticleRequested, this);

                LEConnection.vent.on('KPsTabController:scrollTop', this._scrollTop, this);
            },

            _setListeners: function() {
                this.listenTo(this.connectionPanelContextModel, "change:referrerAction", this._scrollRecentIntoView);
            },

            _showSearchInputRegion: function (options) {
                if (options && options.view) {
                    this._showRegion(this.kpsTabLayout.searchInputRegion, options.view);
                }
            },
            _showSearchResultsRegion: function (options) {
                if (options && options.view) {
                    this._showRegion(this.kpsTabLayout.searchResultsRegion, options.view);
                }
            },
            _showWhatsNewRegion: function (options) {
                if (options && options.view) {
                    this._showRegion(this.kpsTabLayout.whatsNewRegion, options.view);
                }
            },
            _showPageRegion: function (options) {
                if (options && options.view) {
                    this._showRegion(this.kpsTabLayout.pageRegion, options.view);
                }
            },
            _showAreaRegion: function (options) {
                if (options && options.view) {
                    this._showRegion(this.kpsTabLayout.areaRegion, options.view);
                }
            },
            _showRecentRegion: function (options) {
                if (options && options.view) {
                    this._showRegion(this.kpsTabLayout.recentRegion, options.view);
                }
            },
            _showRegion: function (region, view) {
                if (this.kpsTabLayout.getIsRendered()) {
                    region.show(view);
                }
                else {
                    this.listenTo(this.kpsTabLayout, "render", function () {
                        region.show(view);
                    });
                }
            },
            _closeSearchInputRegion: function (options) {
                this.kpsTabLayout.searchInputRegion.reset();
            },
            _closeSearchResultsRegion: function (options) {
                this.kpsTabLayout.searchResultsRegion.reset();
            },
            _closeWhatsNewRegion: function (options) {
                this.kpsTabLayout.whatsNewRegion.reset();
            },
            _closePageRegion: function (options) {
                this.kpsTabLayout.pageRegion.reset();
            },
            _closeAreaRegion: function (options) {
                this.kpsTabLayout.areaRegion.reset();
            },
            _closeRecentRegion: function (options) {
                this.kpsTabLayout.recentRegion.reset();
            },

            _onArticleRequested: function (options) {
                var snippetModel;

                if (this._isAlreadyShowingCurrentSlug(options.slug)) {
                    return;
                }

                // first locally
                snippetModel = this._getFromLocal(options.slug);

                if(_.isObject(snippetModel)) {
                    this._setSnippetToContext(snippetModel, options.referrerAction);
                }

                // if local fails then try remotely
                else {
                    this._requestModelFromServer(options.slug, options.referrerAction);
                }

            },

            _requestModelFromServer: function (slug, referrerAction) {
                var lang = this.connectionPanelContextModel.get("locale");
                var newModel = new SnippetModel({slug: slug, lang: lang});

                newModel.fetch({
                    slug: slug,
                    lang: lang,
                    referrerAction: referrerAction,
                    success: _.bind(this._onNewSnippetFetchSuccess, this),
                    error: _.bind(this._onNewSnippetFetchError, this)
                });
            },

            _onNewSnippetFetchSuccess: function (model, response, options) {
                // check if empty array
                if (_.isEmpty(response)) {
                    this._onNewSnippetFetchError(model, response, options);
                    return;
                }
                this._setSnippetToContext(model, options.referrerAction);
            },

            _onNewSnippetFetchError: function (model, response, options) {
                LEConnection.vent.trigger("article:error");
            },

            _getFromLocal: function (slug) {
                var queryResult;
                var controllers = [this.kpsSearchController, this.pageSnippetsController,
                    this.areaSnippetsController, this.recentSnippetsController];

                _.find(controllers, function (controller) {
                    if(controller) {
                        queryResult = controller.findSlugInCollection(slug);
                    }
                    return !!queryResult;
                });

                return queryResult;
            },

            _setSnippetToContext: function (model, type) {
                LEConnection.trigger("kpSnippet:selected",{
                    snippetModel:model,
                    type:type
                });
            },

            _isAlreadyShowingCurrentSlug: function (slug) {
                var result = false;
                var currentSlug = this._getCurrentSlug();

                if(currentSlug === slug) {
                    result = true;
                }

                return result;
            },

            _getCurrentSlug: function () {
                var result;
                var selectedKP = this.connectionPanelContextModel.get("selectedKP");

                if(selectedKP) {
                    result = selectedKP.get("slug");
                }

                return result;
            },
            _setLoader:function(){
                this.kpsTabLayout.setLoader();
            },
            _closeLoader: function () {
                this.kpsTabLayout.closeLoader();
            },
            _setNoData:function(){
                this.kpsTabLayout.setNoData();
            },
            _scrollTop:function(){
                this.kpsTabLayout.scrollTop();
            },

            _scrollRecentIntoView: function(model, referrerAction) {
                if (referrerAction === "recentSnippet") {
                    this.kpsTabLayout.setRecentlyPosition();
                }
            }
        });
    });
    return KPsTabController;
});


